export const getNonce = () => {
  const metaNonce = document.querySelector("meta[name='csp-nonce']");
  return metaNonce ? metaNonce.getAttribute('content') : 'testenv';
}
